export default {
    'en': {


    },
    'de': {

    },
    'fr': {

    },
    'nl': {

    },
    'el': {

    }
}